module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ea55f6af25d3914c1049b738643d348.png";